import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8e7f45e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications-page p-8 space-y-6 rounded-lg bg-white" }
const _hoisted_2 = { class: "notifications-header flex justify-between items-center" }
const _hoisted_3 = { class: "notifications-title text-4xl" }
const _hoisted_4 = {
  class: "notifications-wrapper space-y-2",
  "data-pagination-scroll-anchor": ""
}
const _hoisted_5 = { class: "text-right p-2" }
const _hoisted_6 = { class: "mr-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "notification__message" }
const _hoisted_9 = { class: "notification__date" }
const _hoisted_10 = { class: "notification__checkbox" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "flex flex-row-reverse" }

import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Button } from "@/components/common";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { NotificationActions } from "@/store/modules/notification/actions";
import { NotificationGetters } from "@/store/modules/notification/getters";
import { INotification } from "@/store/modules/notification/state";
import { resolveLocalizedText, tLocalized } from "@/utils/localization";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();

const readedMessages = ref<Array<string>>([]);
const currentPage = ref(1);
const setAllCheckedIsClicked = ref(false);

const dataProvider = computed(() => store.getters[NotificationGetters.GET_DATA_PROVIDER]);
const items = computed(() => dataProvider.value.items || []);
const pager = computed(() => dataProvider.value.pager);

const getPage = async (page: number) => {
  currentPage.value = page;
  await store.dispatch(NotificationActions.FETCH_DATA_PROVIDER, {
    page: currentPage.value,
  });
};

async function setReaded() {
  if (readedMessages.value.length === 0) {
    return;
  }

  await store.dispatch(NotificationActions.SET_NOTIFICATIONS_READED, {
    notificationIds: readedMessages.value,
  });

  await store.dispatch(NotificationActions.FETCH_DATA_PROVIDER, {
    page: currentPage.value,
  });

  setAllCheckedIsClicked.value = false;
  readedMessages.value = [];
}

async function setAllChecked() {
  if (!setAllCheckedIsClicked.value) {
    readedMessages.value = [];
    return;
  }

  try {
    const unreadIds = await store.dispatch(NotificationActions.FETCH_UNREAD_IDS);
    readedMessages.value = Array.isArray(unreadIds) ? unreadIds : [];
  } catch (error) {
    // Fallback to current page if unread-ids endpoint is unavailable.
    readedMessages.value = items.value
      .filter((item: INotification) => !item.readed)
      .map((item: INotification) => item.id);
  }
}

function parseNotificationInfo(info?: string | null) {
  if (!info) {
    return null;
  }

  try {
    return JSON.parse(info);
  } catch (error) {
    return null;
  }
}

function isNotificationNavigable(item: INotification) {
  return !!parseNotificationInfo(item.info);
}

function openNotification(item: INotification) {
  const info = parseNotificationInfo(item.info);
  if (!info?.route) {
    return;
  }

  switch (info.route) {
    case "PROCESS_USER_DETAILS":
      if (info.processUserId) {
        router.push(`/documents/process-user/${info.processUserId}`);
      }
      break;
    case "ENTITY_APPROVAL":
      if (info.approvalId) {
        router.push(`/entity-approval/${info.approvalId}`);
      } else {
        router.push("/entity-approval");
      }
      break;
    case "DOCUMENT_STRUCTURE":
      router.push("/documents/document-constructor");
      break;
    case "PROFILE":
      router.push("/profile");
      break;
    case "DOCUMENTS":
      router.push("/documents/document");
      break;
    case "DOCUMENT_DETAILS":
      if (info.documentId) {
        router.push(`/documents/document/${info.documentId}`);
      } else {
        router.push("/documents/document");
      }
      break;
    default:
      break;
  }
}

onMounted(async () => {
  await store.dispatch(NotificationActions.FETCH_DATA_PROVIDER, {
    page: currentPage.value,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(tLocalized)({
            ru: "Список внутрисистемных уведомлений",
            en: "Internal notifications",
            kk: "Жүйеішілік хабарламалар тізімі",
          })), 1),
      _createVNode(_unref(Button), {
        disabled: readedMessages.value.length === 0,
        onClick: setReaded
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(tLocalized)({
            ru: "Отметить прочитанным",
            en: "Mark as read",
            kk: "Оқылған деп белгілеу",
          })), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(tLocalized)({
              ru: "Выделить всё",
              en: "Select all",
              kk: "Барлығын белгілеу",
            })), 1),
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((setAllCheckedIsClicked).value = $event)),
          onChange: setAllChecked
        }, null, 544), [
          [_vModelCheckbox, setAllCheckedIsClicked.value]
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["notification", {
          'notification--readed': item.readed,
          'notification--clickable': isNotificationNavigable(item),
        }]),
          onClick: ($event: any) => (openNotification(item))
        }, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(resolveLocalizedText)(item.message)), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(new Date(item.createdAt).toLocaleDateString()) + " " + _toDisplayString(new Date(item.createdAt).toLocaleTimeString()), 1),
          _createElementVNode("div", _hoisted_10, [
            (!item.readed)
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((readedMessages).value = $event)),
                  value: item.id,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                }, null, 8, _hoisted_11)), [
                  [_vModelCheckbox, readedMessages.value]
                ])
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_7))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(TablePagination, {
        current: _unref(pager).currentPage,
        "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((_unref(pager).currentPage) = $event)),
        "total-pages": _unref(pager).totalPages,
        "onUpdate:total-pages": _cache[4] || (_cache[4] = ($event: any) => ((_unref(pager).totalPages) = $event)),
        "start-page": _unref(pager).startPage,
        "end-page": _unref(pager).endPage,
        onPageChanged: getPage
      }, null, 8, ["current", "total-pages", "start-page", "end-page"])
    ])
  ]))
}
}

})